import { useEffect } from 'react';
import { useNavigate} from 'react-router-dom';
import BtnRounded from './BtnRounded';

const ReviewsWidget = () => {
  // const navigate = useNavigate()
  // const handleClick = (e)=>{
  //   e.preventDefault()
  //   navigate('/contact')
  // }
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widget.trustmary.com/HmF4l1UZF';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      console.log("ReviewsWidget unmounted");
      const root = document.getElementById('root');
      if (root && root.contains(script)) {
        root.removeChild(script); // Nettoyage si le script est bien présent
      }
    };
  }, []);

  return (
    <div className="relative min-h-10">
    
  </div>
  );
};

export default ReviewsWidget;
